import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const DialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
      padding: "25px 25px",
      borderRadius: "15px",
      width: "100%",
      justifyContent: "center",
      overflowY: "scroll",
    },
    title: {
      fontSize: "20px",
      marginBottom: "16px",
      fontWeight: theme.typography.fontWeightRegular,
    },
    qrCodeContainer: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    textField: {
      height: "40px",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: 600,
      textTransform: "capitalize",
      [theme.breakpoints.down("sm")]: {
        height: "20px",
        textAlign: "center",
        fontSize: "20px",
        fontWeight: 600,
        textTransform: "capitalize",
      },
    },
    hideOnDesktop: {
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    hideOnMobile: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  }),
);
